import { Divider, BackTop } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { LoremIpsum } from 'react-lorem-ipsum';
import React from 'react'
import '../styles/Base.scss'

export default function OurMissionPage() {
    const screen = useBreakpoint();

    return (
        <div className={`home-content`} style={{ marginLeft: screen.md ? "15%": "0%", maxWidth: screen.md ? "70%": "100%"}}>
            <BackTop />
            <div className="home-title">
                <div className="title">
                    News and Events
                </div>
                <div className="paragraph">
    <table style={{ border: "none" }}>
        <tbody>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                    <td>July 2025</td>
                    <td>Keynote Talk by Joaquim Jorge at the Faculty of ICT, University of Malta, <a href='https://www.facebook.com/um.ictfaculty/videos/1440731713618568'>🎥 Watch the keynote starting at 3:57:20</a></td>
                </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td>January 2025 </td>
                <td>We've been accepted to deliver a seminar on <a href='https://www.dagstuhl.de/seminars/seminar-calendar/seminar-details/25031'>"Addressing Future Challenges of Telemedicine Applications"</a> at Dagstuhl.</td>
            </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td>January 2025</td>
                <td>Stay tuned for updates on the ongoing organization of the <a href='https://aixvr.tecnico.ulisboa.pt/'>IEEE Conference on AIxVR 2025</a>.</td>
            </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td>November 2024 </td>
                <td>Professor Joaquim Jorge delivered a keynote talk at the <a href='https://icir.ieee.org/2024-keynotes/'>2024 IEEE 3rd International Conference on Intelligent Reality (ICIR 2024)</a>, focusing on XAVIER: eXplainable Artificial intelligence and VIrtual reality for Enhanced Radiology.</td>
            </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td>November 2024 </td>
                <td>Catarina Moreira delivered a keynote talk about the XAVIER project in India.</td>
            </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td>May 2024 </td>
                <td>Explore our cutting-edge research featured in <a href='https://ercim-news.ercim.eu/en137'>ERCIM News 137</a>:"Immersive Virtual Colonoscopy"
                Authored by Anderson Maciel (Técnico Lisboa), Catarina Moreira (University of Technology Sydney), and Joaquim Jorge (Técnico Lisboa).</td>
            </tr>
            <tr>
                <td style={{ width: "20%", borderBottom: "10px solid transparent" }}>2024</td>
                <td style={{ borderBottom: "10px solid transparent" }}>Catarina Moreira presented "XAVIER: eXplainable Artificial Intelligence and Virtual Reality for Enhanced Radiology" at IEEE AIxVR 2024.</td>
            </tr>
            <tr>
                <td style={{ borderBottom: "10px solid transparent" }}>December 2023</td>
                <td style={{ borderBottom: "10px solid transparent" }}>Our team presented "Approaches and Challenges in XR and AI for Health Applications" at SIGGRAPH Asia 2023 Courses.</td>
            </tr>
            <tr style={{ borderBottom: "10px solid transparent" }}>
                <td style={{ width: "20%" }}>2023</td>
                <td>We organized the XR Health workshop - <a href='https://sites.google.com/view/xrhealth/'>XR Technologies for Healthcare and Wellbeing at IEEE VR 2023</a>.</td>
            </tr>
            <tr>
                <td style={{ borderBottom: "10px solid transparent" }}></td>
                <td style={{ borderBottom: "10px solid transparent" }}> <a href="https://www.dropbox.com/scl/fi/urssh7gmncbh0h8u8djn7/UNESCO-CoChair-AIXR.mp4?rlkey=1c83ee7vd4gawac4sxf07ez89&dl=0">Check out our TED talk</a>, where we shared insights into the XAVIER project and our UNESCO Chair on AI & XR.</td>
            </tr>
            <tr>
                <td style={{ borderBottom: "10px solid transparent" }}></td>
                <td style={{ borderBottom: "10px solid transparent" }}>We've established research collaborations with various institutions under FLAD, including Clemson University, University of North Carolina, Greensboro, and Duke University.</td>
            </tr>
            <tr>
                <td style={{ borderBottom: "10px solid transparent" }}></td>
                <td style={{ borderBottom: "10px solid transparent" }}>Co-PI Catarina Moreira received the Premio iNOVA+ for her research work on the XAVIER project.</td>
            </tr>
            <tr>
                <td style={{ borderBottom: "10px solid transparent" }}></td>
                <td style={{ borderBottom: "10px solid transparent" }}>Keep an eye out for our special sections on AI&XR for Health and EyeTrack VISA in Computers & Graphics journals.</td>
            </tr>
            <tr>
                <td style={{ width: "20%", borderBottom: "10px solid transparent" }}>January 2023</td>
                <td style={{ borderBottom: "10px solid transparent" }}>The Xavier project start date</td>
            </tr>
            
        </tbody>
    </table>
</div>


                {/* <div className="paragraph">
                <ul>
                        <li>The Xavier project started on 01/01/2023.</li>
                        <li>SIGGRAPH Asia 2023 Courses: Our team presented "Approaches and Challenges in XR and AI for Health Applications" at SIGGRAPH Asia 2023 Courses in December 2023.</li>
                        <li>TED Talk on AI & XR: <a href="https://www.dropbox.com/scl/fi/urssh7gmncbh0h8u8djn7/UNESCO-CoChair-AIXR.mp4?rlkey=1c83ee7vd4gawac4sxf07ez89&dl=0">Check out our TED talk</a>, where we shared insights into the XAVIER project and our UNESCO Chair on AI & XR.</li>
                        <li>Research Collaborations with FLAD: We've established research collaborations with various institutions under FLAD, including Clemson University, University of North Carolina, Greensboro, and Duke University.</li>
                        <li>Achievements: Co-PI Catarina Moreira received the Premio iNOVA+ for her research work on the XAVIER project.</li>
                        <li>Special Sections in Computers & Graphics Journals: Keep an eye out for our special sections on AI&XR for Health and EyeTrack VISA in Computers & Graphics journals.</li>
                        <li>Public Talks: Catarina Moreira presented "XAVIER: eXplainable Artificial Intelligence and Virtual Reality for Enhanced Radiology" at IEEE AIxVR 2024.</li>

                </ul>
                
                </div> */}
            </div>
            
            
            <div className="home-title">
                

                <div className="paragraph">
                
                     {/* <ul>
                        
                        <li>2nd Workshop XR Health: We organized the XR Health workshop -<a href='https://sites.google.com/view/xrhealth/'>XR Technologies for Healthcare and Wellbeing at IEEE VR 2023</a> .</li>
                        <li>IEEE Conference on AIxVR 2025: Stay tuned for updates on the ongoing organization of the <a href='https://aixvr.tecnico.ulisboa.pt/'>IEEE Conference on AIxVR 2025</a>.</li>
                        <li>Dagstuhl Seminar on Telemedicine Applications: We've been accepted to deliver a seminar on <a href='https://www.dagstuhl.de/seminars/seminar-calendar/seminar-details/25031'>"Addressing Future Challenges of Telemedicine Applications"</a> in January 2025 at Dagstuhl.</li>

                    </ul>  */}
                </div>
            </div>

            {/* <Divider /> */}
            {/* <div className="home-title">
                <div className="title">
                    Our Values
                </div>

                <div className="paragraph">
                <ul>


                    <li>
                        Pursuit of Excellence
                    </li>

                    <li>
                        Creativity and Critical Thinking
                    </li>

                    <li>
                        Diversity and Inclusiveness
                    </li>
                    <li>
                        Positivity and Passion
                    </li>
                </ul>
                </div>
            </div>

            <Divider /> */}
            {/* <div className="home-title">
                <div className="title">
                Acknowledgement
                </div>

                <div className="paragraph">
                <ul>
                    <li>
                    QUT Women in Research Grant Scheme 2021 
                    </li>

                    <li>
                    QUT Center for Data Science First Byte Funding Program 2021 
                    </li>

                    <li>
                    Australian Government Research Training Program (International) Scholarship 2019 – 2022 
                    </li>

                    <li>
                    Australian Government Research Training Program (International) Scholarship 2020 – 2023 
                    </li>

                    <li>
                    Australian Government Research Training Program (Domestic) Scholarship 2020 – 2023 
                    </li>

                    <li>
                    QUT Science and Engineering Faculty Diversity Scholarship 2020 – 2023  
                    </li>

                    <li>
                    QUT Postgraduate Research Award (International) Scholarship 2021 – 2024
                    </li>

                    <li>
                    QUT Science and Engineering Faculty Scholarship 2021 – 2024 
                    </li>

                    <li>
                    QUT Centre for Data Science Higher Degree Research Scholarship 2021 – 2024
                    </li>

                    <li>
                    QUT Center for Data Science Top Up Scholarship 2021 – 2024
                    </li>

                    <li>
                    QUT Vacation Research Experience Scheme Scholarship 2020
                    </li>

                    <li>
                    QUT International Merit Scholarship 2021 
                    </li>

                    <li>
                    Higher Degree Research Internship Industry Scholarship 2021 
                    </li>
                </ul>
                </div>
            </div> */}

        </div >
    )
}
